export default "__VITE_ASSET__Dpb2UdVm__"